import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Profile"],
});

const profileApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: () => `/teacher/profile`,
      providesTags: ["Profile"],
    }),

    getUserProfile: builder.query({
      query: () => `/auth/profile`,
      providesTags: ["Profile"],
    }),

    getMyActivity: builder.query({
      query: ({ page = 1, per_page = 10 } = {}) =>
        `/activity/mine?page=${page}&per_page=${per_page}`,
    }),

    updateProfile: builder.mutation({
      query: (values) => ({
        url: "/teacher/profile",
        method: "PATCH",
        body: { ...values },
      }),
      invalidatesTags: ["Profile"],
    }),

    updateUserProfile: builder.mutation({
      query: (values) => ({
        url: "/auth/profile",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Profile"],
    }),
  }),
});

export const {
  useGetProfileQuery,
  useGetUserProfileQuery,
  useGetMyActivityQuery,
  useUpdateProfileMutation,
  useUpdateUserProfileMutation,
} = profileApiSlice;
